import { type ErrorCodeMap } from './types';

export const recordingErrorCodes: ErrorCodeMap = {
  RECORDING_INTEGRITY_FAILED: 'desktop.errors.recording.integrityFailed',
  RECORDING_WRITE_ERROR: 'desktop.errors.recording.writeError',
  RECORDING_FILE_ERROR: 'desktop.errors.recording.fileError',
  RECORDING_WRITE_TIMEOUT: 'desktop.errors.recording.writeTimeout',
  RECORDING_WRITER_UNAVAILABLE: 'desktop.errors.recording.writerUnavailable',
  RECORDING_TASK_PANIC: 'desktop.errors.recording.taskPanic',
  RECORDING_TASK_ERROR: 'desktop.errors.recording.taskError',
  RECORDING_INTERNAL_ERROR: 'desktop.errors.recording.internalError',
  RECORDING_PROCESSING_FAILED: 'desktop.errors.recording.processingFailed',
};
